// @flow

import axios from "../dependencies/_axios";

export function accountSetupCreateApi(data: Object) {
	return axios({
		url: '/support-dashboard/account-setup',
		timeout: 20000,
		method: 'post',
		responseType: 'json',
		headers: {'X-Requested-With': 'XMLHttpRequest'},
		data
	})
}

export function accountSetupFetchHistoryApi(params: Object) {
	return axios({
		url: '/support-dashboard/account-setup',
		timeout: 20000,
		method: 'get',
		responseType: 'json',
		headers: {'X-Requested-With': 'XMLHttpRequest'},
		params
	})
}

export function accountSetupResendApi(id: number) {
	return axios({
		url: `/support-dashboard/account-setup/${id}/resend`,
		timeout: 20000,
		method: 'post',
		responseType: 'json',
		headers: {'X-Requested-With': 'XMLHttpRequest'}
	})
}
